import parseFeedback from "./parseFeedback";

const PeerEvaluationFeedback = props => {
  const {
    question,
    showError,
    self_assessment_count,
    answers,
    peer_rating_count,
    onChange,
    teamList,
    currentUserId,
    feedbacks,
    previousAnswers,
    readonlyMode,
    adjustedScore
  } = props;

  return parseFeedback({
    question,
    answers,
    showError,
    self_assessment_count,
    peer_rating_count,
    onChange,
    teamList,
    currentUserId,
    feedbacks,
    previousAnswers,
    readonlyMode,
    adjustedScore
  });
};

export default PeerEvaluationFeedback;



// WEBPACK FOOTER //
// ./src/components/peer-evaluation/peer-evaluation-feedback/index.js